import AuctionEndOrStart from 'components/Auctions/AuctionEndOrStart'
import { user_formatted_date, user_formatted_time } from 'helpers/date'

function AuctionExpires({ auction, postReview = false, }) {
    const {
        status_id,
        expire_date,
        cancel_date,
        original_active_date: active_date,
        upcoming,
        user,
        expire_date_obj: _expire_date,
        user: { timezone = 'America/Phoenix' } = {}
    } = auction

    if (postReview) {
        return <AuctionEndOrStart upcoming={upcoming} expire_date={_expire_date} active_date={active_date} user={user} />
    }

    switch (status_id) {
        case '1':
            return <AuctionEndOrStart {...auction} />
        case '2':
            return (
                <div className="details-expires">
                    Auction ended on
                    {' '}
                    <div className="ends-on-xs-break"/>
                    <strong>{user_formatted_date(expire_date)}</strong>
                    {' '}
                    at
                    {' '}
                    <strong>{user_formatted_time(expire_date)}</strong>
                    <br/>
                    (
                    {timezone}
                    )
                </div>
            )
        case '3':
            return (
                <div className="details-expires">
                    This auction expired on
                    {' '}
                    <div className="ends-on-xs-break"/>
                    <strong>{user_formatted_date(expire_date)}</strong>
                    {' '}
                    at
                    {' '}
                    <strong>{user_formatted_time(expire_date)}</strong>
                    <br/>
                    (
                    {timezone}
                    )
                </div>
            )
        case '4':
        case '5':
            return (
                <div className="details-expires">
                    This auction has been canceled on
                    {' '}
                    <div className="ends-on-xs-break"/>
                    <strong>{user_formatted_date(cancel_date)}</strong>
                    {' '}
                    at
                    {' '}
                    <strong>{user_formatted_time(cancel_date)}</strong>
                    <br/>
                    (
                    {timezone}
                    )
                </div>
            )
        default:
            return null
    }
}

export default AuctionExpires